export let paymentStatesOfScan = [{
  label: '待支付',
  value: 'WAITING_FOR_PAYMENT'
},
{
  label: '已完成',
  value: 'COMPLETED'
},
{
  label:"退款中",
  value:"REFUNDING"
},
{
  label: '已关闭',
  value: 'CLOSED'
},
{
  label: '未支付关闭',
  value: 'NO_PAYMENT_CLOSED'
}
]
